import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';
import { AlertFacade } from '@surface-elements/shared/alert-system/data-access';
import {
  AlertType,
  PersistenceLevel,
} from '@surface-elements/shared/alert-system/domain';
import { ErrorTranslatorService } from '@surface-elements/shared/util-error';

@Injectable()
export class HttpErrorAlertInterceptor implements HttpInterceptor {
  private readonly alertFacade = inject(AlertFacade);
  private readonly errorTranslator = inject(ErrorTranslatorService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Use the error translator service for user-friendly messages
        const translatedError = this.errorTranslator.translateError(error);

        this.alertFacade.addAlert({
          type: AlertType.ERROR,
          title: translatedError.title,
          message: translatedError.message,
          dismissible: true,
          duration: 7000,
          persistence: PersistenceLevel.NONE,
        });

        // Log the original error for debugging (only in development)
        if (translatedError.isFallback) {
          console.warn('Using fallback error translation for:', error);
        }

        return throwError(() => error);
      }),
    );
  }
}
